<app-page-loader></app-page-loader>
<!-- <router-outlet></router-outlet> -->

<router-outlet (activate)="onActivate($event)"></router-outlet>